import React, { useEffect } from 'react';
import styled from 'styled-components';
import { GOOGLE } from '@rsos/constants/mapProviders';
import { useZoomAndLocationContext } from './ZoomAndLocationContext';
import { mapOptions as defaultMapOptions } from './mapDefaults';
import useGoogleMap from './useGoogleMap';

const GMap = styled.div`
  width: 100%;
  height: 100%;

  ${({ isICSP }) => {
    return isICSP
      ? `border-radius: 5px;
    border: 1px solid #5B778D;
    `
      : '';
  }}
`;

/**
 * Google Maps container
 * @param {String} apiKey - API key for Google Maps
 * @param {boolean} isICSP - is incident central station or not
 * @param {String} mapId - Google Maps ID for applying custom styling (e.g., light or dark mode).
 * @param {Object} mapOptions - Google Maps options
 * @param {Function} onReady - Callback for when the map is ready
 */
const GoogleMap = ({
  apiKey = '',
  isICSP = false,
  mapId = '',
  mapOptions = defaultMapOptions,
  onReady = () => {},
}) => {
  const { setMap } = useZoomAndLocationContext();
  const updatedMapOptions = {
    ...mapOptions,
    controlSize: isICSP ? '25' : '40',
  };

  const { initialized, mapInstance, mapRef } = useGoogleMap({
    apiKey,
    mapId,
    options: updatedMapOptions,
    styles: [],
  });

  // Callback for when map is ready
  useEffect(() => {
    if (initialized) {
      setMap(mapInstance ? { mapProvider: GOOGLE, mapInstance } : null);
      onReady(mapInstance, mapRef);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialized, mapInstance, mapRef]);

  return <GMap isICSP={isICSP} ref={mapRef} />;
};

export default GoogleMap;
